<template>
    <div class="drawerLayer" style="z-index: 999" v-show="visible">

        <div class="topDrawer white_bg myAddressDrawer fullSpace" style="overflow: auto">
            <header class="pageHeader white_bg bottomBorderBBB" style="line-height: 46px;">
                <div class="flexLayout paddingH16">
                    <div style="width: 16%">
                        <span class="icon leftAngleBracketIcon floatL" style="margin-top: 12px;" @click="back()"></span>
                    </div>
                    <div class="flexItem alignCenter font18r primaryTextColor bold hiddenOverflow"
                         style="height: 46px; ">
                        {{title}}
                    </div>
                    <div class="font14r alignRight orange" style="width: 16%">
                        <span @click="ok()" v-if="activeView=='list'">确认</span>
                    </div>
                </div>
            </header>

            <div class="body">

                <div class="paddingH12" v-if="activeView=='list'">

                    <div class="dataItem" v-for="(dataItem, index) in dataList" :key="dataItem.id"
                        style="padding: 12px 0;">
                        <div class="flexLayout">
                            <div style="width: 26px;">
                                <input type="radio" class="modernCheckbox orangeCircleTickCheckbox marginT20"
                                    :value="index" v-model="selectedIndex"/>
                            </div>
                            <div class="flexItem">
                                <div class="color101010 font14r marginB4" :data-userid="dataItem.userId">
                                    {{dataItem.username}}，{{dataItem.phone}}
                                </div>
                                <div class="color999 font12r">
                                    {{dataItem.region + dataItem.address}}
                                </div>
                            </div>
                            <div class="alignR" style="width: 34px;">
                                <i class="fa fa-edit marginT20" style="width: 18px; height: 18px;"
                                    @click="editItem(dataItem)"></i>
                            </div>

                        </div>
                    </div>

                    <div class="alignCenter paddingV8" v-show="status === 'loading'">
                        <i class="icon spinner-loader"></i>
                    </div>

                    <div class="paddingV16 colorCCC font14r alignC"
                         v-show="(status == 'ready' || status == '') &&  dataList.length < 1">
                        <img src="shopping/take_delivery_address.png" style="max-width: 100%"/>
                    </div>

                    <div class="paddingV16 colorCCC font14r alignC"
                         v-show="status == 'error'">
                        加载数据失败
                    </div>

                    <div style="height: 110px">
                        <div class="padding12 borderBoxSize w100p absoluteBottomLeft" style="height: 110px">
                            <a href="javascript:;" class="button buttonForNew block font18r" @click="add()">
                                新建收货地址
                            </a>
                        </div>
                    </div>

                </div><!-- end list view -->

                <div v-if="activeView=='edit'">
                    <div class="formRow">
                        <div class="columnName">姓名</div>
                        <div class="columnValue">
                            <input type="text" class="inputbox block" placeholder="收货人姓名" v-model="dataItem.username"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">电话</div>
                        <div class="columnValue">
                            <input type="text" class="inputbox block" placeholder="收货人手机号" v-model="dataItem.phone"/>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">地区</div>
                        <div class="columnValue">
                            <!--                        <input type="text" class="inputbox block" placeholder="收货人姓名"/>-->
                            <!--                        <van-cascader-->
                            <!--                            v-model="dataItem.area"-->
                            <!--                            title="请选择所在地区"-->
                            <!--                            :options="areaOptions"-->
                            <!--                            :field-names="areaFieldNames"-->
                            <!--                        />-->
                            <div class="" @click="showAreaSelector = true">
                                <span style="color: #b8c2d6" v-if="!dataItem.region">请选择所在地区</span>
                                <span v-else>
<!--                                    {{dataItem.province}} &nbsp;-->
<!--                                    {{dataItem.city}} &nbsp;-->
<!--                                    {{dataItem.district}}-->
                                    {{dataItem.region}}
                                </span>
                            </div>
                            <van-popup v-model:show="showAreaSelector" round position="bottom">
                                <van-cascader
                                    v-model="dataItem.area"
                                    title="请选择所在地区"
                                    :options="areaOptions"
                                    :field-names="areaFieldNames"
                                    @close="showAreaSelector = false"
                                    @finish="onSelectAreaFinish"
                                />
                            </van-popup>
                        </div>
                    </div>
                    <div class="formRow">
                        <div class="columnName">详细地址</div>
                        <div class="columnValue">
                        <textarea class="inputbox block" style="min-height: 80px; padding: 0;"
                                  placeholder="街道门牌、楼层房间号等信息" v-model="dataItem.address"/>
                        </div>
                    </div>


                    <div class="paddingH12 tagArea paddingT20 marginT8">
                    <span class="textLabel orangeTextLabel" :class="{active: tagItem == dataItem.positonType}"
                          v-for="tagItem in tagList" :key="tagItem" @click="dataItem.positonType=tagItem">
                        {{tagItem}}
                    </span>
                    </div>

                    <div class="paddingH20" style="margin-top: 55px;">
                        <button class="button block buttonForSave font18r" @click="save()">保存</button>
                        <button class="button block buttonForDelete font18r marginT16" v-show="dataItem && !dataItem.id"
                            @click="onDelete()">
                            删除
                        </button>
                    </div>
                </div>

            </div><!-- end .body -->
        </div>
    </div>
</template>

<script>
import drawerPart from '../part/drawerPart';

import { cascader } from 'vant';
import { Popup } from 'vant';
import { Field } from 'vant';

// config
import appConfig from '@/appConfig';

// util
import appHelper        from '@/util/appHelper';
import dataMixedUtils   from "@/util/dataMixedUtils";
import citiesList_v3 from "@data/citiesList_v3";
import consoleApi from "@comp/platformApi/consoleApi";
import payApi from "@comp/deal/payApi";

const config = {
    name : 'myAddressDrawer',
    title : '地址管理',
    description : '',
    apiConfig : {
        list : {
            url : 'portal/v4/user/center/getAddress',
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            totalPath : 'data.total'
        },
        get : {
            url : 'portal/v4/user/center/get',
            dataPath : 'data'
        },
        add : {
            url : 'portal/v4/user/center/upSert',
            method : 'post'
        },
        update : {
            url : 'portal/v4/user/center/upSert',
            method : 'post'
        },
        delete : {
            url : 'portal/v4/user/center/detelte/address',
            method : 'delete'
        }

    },
    demoTitleList : [
        '奥尔夫音乐课程春秋课新精选课程',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: config.name,
    extends : drawerPart,
    components : {
        [cascader.name]: cascader,
        [Field.name]: Field,
        [Popup.name]: Popup
    },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            // pageSize : 8,
            enableDataList : true,
            autoLoadDataList : appConfig.mode != 'demo',
            enableDataItem : true,
            activeView : 'list',   // list | edit,

            dataItem : {
                id : '',
                username : '',
                phone : '',
                province : '',
                city : '',
                // area : '',
                district  : '',
                address : '',
                positonType: '',
                // zipCode: '',
                isDefault : 0
            },
            showAreaSelector : false,
            areaOptions : citiesList_v3,
            areaFieldNames : {
                text: 'text',
                value: 'value',
                children: 'children',
            },
            tagList : ['园所','公司','家','其他'],
            selectedIndex : 0
        }
    },
    methods : {
        back() {
            if (this.activeView=='list')
            {
                this.close();
            }
            else {
                this.resetDataItem();
                this.activeView = 'list';
            }
        },
        viewItem(dataItem) {
            appHelper.goToPage('', {
                id : dataItem.id
            });
        },
        editItem(dataItem) {
            // appHelper.redirect('/shopping/editAddress/' + dataItem.id);
            this.loadDataItem(dataItem.id);
            this.activeView = 'edit';
        },
        add() {
            this.resetDataItem();
            this.activeView='edit';
        },
        ok() {
            let index = parseInt(this.selectedIndex);
            let selectedItem = this.dataList[index];
            // this.$emit('selectAddress', {
            //     data : {
            //         username: selectedItem.username,
            //         phone: selectedItem.phone,
            //         region: selectedItem.region,
            //         address: selectedItem.address,
            //         positonType: selectedItem.positonType
            //     }
            // });
            this.$emit('selectAddress', {
                '姓名': selectedItem.username,
                '联系电话': selectedItem.phone,
                '地区': selectedItem.region,
                '收货地址': selectedItem.address,
                '标签': selectedItem.positonType
            });
            this.close();
        },
        onSelectAreaFinish(result) {
            this.showAreaSelector = false;

            consoleApi.log(result.selectedOptions);
            let areaList = result.selectedOptions;

            this.dataItem.province = areaList.length >= 1 ? areaList[0].text : '';
            this.dataItem.city = areaList.length >= 2 ? areaList[1].text : '';
            this.dataItem.district = areaList.length >= 3 ? areaList[2].text : '';
            this.dataItem.region = this.dataItem.province + this.dataItem.city + this.dataItem.district;
        },
        beforeSubmit(data) {
            // data.region = data.province + data.city + data.district;
            delete data.province;
            delete data.city;
            delete data.district;
            return data;
        },
        onSubmitSuccess() {
            appHelper.showHint('保存成功！');
            this.back();
            this.reloadDataList();
        },
        onDelete() {
            appHelper.confirm({
                title : '地址删除提醒',
                content : '亲爱的小主，您确定删除该地址吗？',
                okText : '确认删除',
                cancelText : '考虑一下'
            }, (status) => {
                if (!status) { return; }
                this.removeDataItem();
            });

        },
        onSubmitError(error) {
            appHelper.showHint(error.msg);
        },
    },
    mounted() {

        if (appConfig.mode == 'demo')
        {
            // this.dataList = dataMixedUtils.array.buildDataList(8, (index) => {
            //     return {
            //         id : index,
            //         title : dataMixedUtils.array.getRandomItem(config.demoTitleList),
            //         coverImg : appHelper.getRandomCoverImage(),
            //         userHead : appHelper.getRandomCoverImage(),
            //         createTime : new Date().getTime() - dataMixedUtils.number.getRandomInteger(1000 * 60 * 60 * 24 * 7)
            //     }
            // });
        }
    }
}
</script>

<style lang="scss" scoped>
.buttonForNew {
    background: #F7AA01;
    color: white;
    border-radius: 4px;
    height: 50px;
    line-height: 50px;
}
.orange {
    color: #F7AA01;
}
.formRow {
    display: flex;
    padding: 12px 15px;
    border-bottom: solid 1px #BBB;
    .columnName {
        color: #5B616C;
        flex: 1;
    }
    .columnValue {
        flex: 3;
        .inputbox {
            display: block;
            width: 100%;
            font-size: 16px;
            height: 27px;
            line-height: 27px;
            border: none;
            background: transparent;
            color: hsla(0, 0%, 20%, 1);
            outline: none;
        }
        .inputbox::placeholder,
        .inputbox::-webkit-input-placeholder,
        .inputbox::-moz-placeholder,
        .inputbox::-ms-input-placeholder {
            color: hsla(220, 27%, 78%, 1);
        }
    }
}
.buttonForSave {
    height: 44px;
    border-radius: 25px;
    background-color: rgba(247, 170, 1, 100);
    color: white;
}
.buttonForDelete {
    height: 44px;
    border-radius: 25px;
    border: solid 1px #BBB;
    box-sizing: border-box;
    background-color: transparent;
    color: black;
}
.orangeTextLabel {
    display: inline-block;
    color: #101010;
    border: solid 1px #BBBBBB;
    background: transparent;
    margin-right: 12px;
    width: 65px;
    height: 23px;
    line-height: 23px;
    text-align: center;
    border-radius: 11px;
    padding: 0;

    &.active {
        border: solid 1px #F7AA01;
        color: #F7AA01;
    }
}
</style>

